// File: src/components/forms/SearchField/SearchField.tsx
// Purpose: Form input component

import React, { useState } from "react";
import { Search, X } from "lucide-react";
import { TextField, TextFieldProps } from "../TextField";

export const SearchField: React.FC<Omit<TextFieldProps, "type">> = ({
  onChange,
  ...props
}) => {
  const [query, setQuery] = useState("");

  return (
    <TextField
      {...props}
      type="text"
      icon={query ? X : Search}
      onIconClick={() => setQuery("")}
      debounce={300} // Prevents excessive API calls
      value={query}
      onChange={(e) => {
        setQuery(e.target.value);
        onChange?.(e);
      }}
    />
  );
};